<template>
    <div  :class="[prefixCls]" @mouseenter="handleShowPopper" @mouseleave="handleClosePopper">
        <div :class="[prefixCls + '-rel']" ref="reference">
            <slot></slot>
        </div>
        <template>
            <transition  name="fade">
                <div
                    :class="[prefixCls + '-popper', prefixCls + '-' + theme]"
                    :style="dropStyles"
                    ref="popper"
                    v-show="!disabled && (visible || always)"
                    @mouseenter="handleShowPopper"
                    @mouseleave="handleClosePopper"
                    :data-transfer="transfer"
                    v-transfer-dom:value='{show:!disabled && (visible || always)}'>
                    <div :class="[prefixCls + '-content']">
                        <div :class="[prefixCls + '-arrow']"></div>
                        <div :class="innerClasses" :style="innerStyles"><slot name="content">{{ content }}</slot>
                            <Table
                                size="small"
                                border
                                :style="tableStyle"
                                ref="listTable"
                                :columns="columns"
                                :data="tableData"
                            ></Table>
                        </div>
                    </div>
                </div>
            </transition>
        </template>
    </div>
</template>
<script>
    import Popper from '@/utils/component/popper';
    import TransferDom from '@/utils/component/transfer-dom';
    import { oneOf } from '@/utils/assist';
    import { transferIndex, transferIncrease } from '@/utils/component/transfer-queue';

    const prefixCls = 'ivu-tooltip';

    export default {
        name: 'Tabletip',
        directives: { TransferDom },
        mixins: [Popper],
        props: {
            placement: {
                validator (value) {
                    return oneOf(value, ['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right', 'right-start', 'right-end']);
                },
                default: 'bottom'
            },
            content: {
                type: [String, Number],
                default: ''
            },
            delay: {
                type: Number,
                default: 100
            }, 
            columns:{
                type:Array,
                default:[]
            },
            tableData:{
                type:Array,
                default:[]
            },
            padding:{
                type:[String,Number],
                default:''
            },
            disabled: {
                type: Boolean,
                default: false
            },
            controlled: {    // under this prop,Tooltip will not close when mouseleave
                type: Boolean,
                default: false
            },
            always: {
                type: Boolean,
                default: false
            },
            transfer: {
                type: Boolean,
                default () {
                    return !this.$IHLP || this.$IHLP.transfer === '' ? false : this.$IHLP.transfer;
                }
            },
            theme: {
                validator (value) {
                    return oneOf(value, ['dark', 'light']);
                },
                default: 'dark'
            },
            maxWidth: {
                type: [String, Number]
            }
        },
        data () {
            return {
                prefixCls: prefixCls,
                tIndex: this.handleGetIndex()
            };
        },
        computed: {
            innerStyles () {
                const styles = {};
                if (this.maxWidth) styles['max-width'] = `${this.maxWidth}px`;
                if (this.padding) styles['padding'] = this.padding+'';
                return styles;
            },
             tableStyle () {
                const styles = {};
                if (this.width) styles['width'] = this.width+'';
                return styles;
            },
            innerClasses () {
                return [
                    `${prefixCls}-inner`,
                    'table-tip',
                    {
                        [`${prefixCls}-inner-with-width`]: !!this.maxWidth
                    }
                ];
            },
            dropStyles () {
                let styles = {};
                if (this.transfer) styles['z-index'] = 1060 + this.tIndex;
                return styles;
            }
        },
        watch: {
            content () {
                this.updatePopper();
            }
        },
        methods: {
            handleShowPopper() {
                if (this.timeout) clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.visible = true;
                }, this.delay);
                this.tIndex = this.handleGetIndex();
            },
            handleClosePopper() {
                if (this.timeout) {
                    clearTimeout(this.timeout);
                    if (!this.controlled) {
                        this.timeout = setTimeout(() => {
                            this.visible = false;
                        }, 100);
                    }
                }
            },
            handleGetIndex () {
                transferIncrease();
                return transferIndex;
            },
        },
        mounted () {
            if (this.always) {
                this.updatePopper();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/common/tabletip/tabletip.vue